// path: src/pages/IPA/Negociacoes/components/StageNotice/StageNotice.constants.ts
// Textos literais aprovados para o aviso; nao se reescrevem nem para ajustar pontuacao.

export const IMPLEMENTATION_STAGE = {
  WITHOUT_INTEGRATION: 'SEM_INTEGRACAO',
  IN_INTEGRATION: 'EM_INTEGRACAO',
} as const;

export const STAGE_NOTICE_EMAIL = 'atendimento@infoprice.co';

export const MAILTO_PREFIX = 'mailto:';

export const STAGE_NOTICE_TEXTS = {
  withoutIntegration: {
    beforeLink:
      'Esta tela depende da integração de dados com o seu ERP, que ainda não foi feita. Para começar a integração, abra um chamado com o atendimento: ',
    afterLink: '. A Negociação manual já está liberada.',
  },
  inIntegration: {
    SUPPLIER:
      'A integração e a homologação dos seus dados ainda não terminaram. Os dados desta tela podem estar incorretos até a Implantação concluir a validação.',
    SAVED:
      'A integração e a homologação dos seus dados ainda não terminaram. ' +
      'As negociações salvas podem conter dados incorretos até a Implantação concluir a validação.',
  },
} as const;
